import * as v from 'valibot';

// This is an experimental use of Valibot for runtime schema validation and type inference
// hey-api also supports valibot, so in the final cut I expect these will be defined in the
// generated hey-api code, but this is TBD.

export const BoundarySchema = v.object({
  id: v.string(),
  name: v.string(),
  coordinates: v.array(
    v.object({
      lon: v.number(),
      lat: v.number(),
    })
  ),
});
export const BoundariesResponseSchema = v.object({
  boundaries: v.array(BoundarySchema),
});

export type BoundariesResponse = v.InferOutput<typeof BoundariesResponseSchema>;

export type Boundary = v.InferOutput<typeof BoundarySchema>;
